import { render, staticRenderFns } from "./compareBar.vue?vue&type=template&id=3f91a73a&scoped=true&"
import script from "./compareBar.vue?vue&type=script&lang=js&"
export * from "./compareBar.vue?vue&type=script&lang=js&"
import style0 from "./compareBar.vue?vue&type=style&index=0&id=3f91a73a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91a73a",
  null
  
)

export default component.exports